import { Box, Typography } from '@mui/material'
import React, { useState } from 'react'
import { useAppSelector } from 'src/store'
import ExpandLess from '@mui/icons-material/ExpandLess'
import './IngredientDemo.scss'
import UpdateIngredientForm from 'src/forms/UpdateIngredientForm'
import { isEmpty } from 'src/utils'
import DemoMediaItem from '../DemoMediaItem'


export type IngredientDemoProps = {
    // ingredientId?: string
}

const IngredientDemo = (props: IngredientDemoProps) => {
    const ingredient = useAppSelector(x => x.recipes.currentIngredient)
    const isAdmin = useAppSelector(x => x.user.isAdmin)
    const [collapsed, setCollapsed] = useState<boolean>(false)

    const hasBefore = !isEmpty(ingredient?.beforeMediaSrc)
    const hasAfter = !isEmpty(ingredient?.afterMediaSrc)

    if (!ingredient) { return <Box /> }
    return (
        <Box id="ingredient-demo-container">
            <Box id="description-dropdown">
                <Typography variant='h5' className='title'>{ingredient.name}</Typography>
                {!collapsed &&
                    <div className="details">
                        <div className="description" dangerouslySetInnerHTML={{ __html: ingredient.description }} />
                    </div>

                }
                <Box className="collapse-btn" data-collapsed={collapsed} onClick={() => { setCollapsed(!collapsed) }}>
                    <ExpandLess />
                </Box>
            </Box>
            <Box id="ingredient-demo">

                <Box id="ingredient-demonstration">
                    {hasBefore &&
                        <DemoMediaItem
                            key={ingredient.id + 'before'}
                            autoPlay={ingredient.autoPlay}
                            id="before-player"
                            source={ingredient.beforeMediaSrc}
                        />
                    }
                    {hasAfter &&
                        <DemoMediaItem
                            key={ingredient.id + 'after'}
                            autoPlay={ingredient.autoPlay}
                            id="after-player"
                            source={ingredient.afterMediaSrc}
                        />
                    }
                </Box>
            </Box>
            {isAdmin &&
                <Box>
                    <UpdateIngredientForm key={ingredient.id} ingredient={ingredient} />
                </Box>
            }

        </Box>
    )
}

export default IngredientDemo